<template>
    <div class="container-fluid d-flex flex-wrap main-wrapper" style="background-color: #090B09; height: 100vh; overflow-y: scroll; background-size: cover; padding-bottom: 15rem !important; background-attachment: fixed;">
        <!-- <div class="col-lg-3 col-12 pl-0 side-nav-bar-custom">
            <SideNav />
        </div> -->
        <div class="col-12 p-0 mb-5">
            <div class="bg-transparent">
                <div class="pl-2 pt-3 bg-transparent">
                    <div class="align-items-center">
                        <div class="col-8">
                            <h3 class="mb-0" style="color: #fff !important;">
                                {{$t('banking.bank_info')}}
                            </h3>
                        </div>
                    </div>
                </div>
                <div class="error text-center py-2" v-if="error">
                    <span class="mx-auto">
                      {{error}}
                    </span>
                    
                  </div>

                <div class="card-body bg-transparent">
                    <form>
                        <div class="mt-3">
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="form-group">
                                        <label
                                            class="form-control-label"
                                            for="input-email"
                                            style="color: #fff !important; font-size: 1rem; font-weight: 400 !important;"
                                            >{{$t('banking.bank_username')}}</label
                                        >
                                        <input
                                            type="text"
                                            class="form-control custom-input"
                                            v-model="
                                                account.name
                                            "
                                        />
                                        <span class="text-danger">{{
                                            errors.name
                                        }}</span>
                                    </div>
                                </div>

                                <div class="col-lg-12">
                                    <div class="form-group">
                                        <label
                                            class="form-control-label"
                                            for="input-email"
                                            style="color: #fff !important; font-size: 1rem; font-weight: 400 !important;"
                                            >{{$t('banking.bank_number')}}</label
                                        >
                                        <input
                                            type="number"
                                            class="form-control custom-input"
                                            v-model="
                                                account.account_number
                                            "
                                        />
                                        <span class="text-danger">{{
                                            errors.number
                                        }}</span>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <div class="form-group">
                                                <label
                                                    class="form-control-label"
                                                    for="input-username"
                                                    style="color: #fff !important; font-size: 1rem; font-weight: 400 !important;"
                                                    >{{$t('banking.bank_type')}}</label
                                                >
                                                <AccountSelect
                                                    :data="account"
                                                    field="type"
                                                    :accounts="accounts"
                                                />
                                                <span class="text-danger">{{
                                                    errors.account
                                                }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group col-12 mt-2">
                                    <button
                                        type="button"
                                        class="btn btn-primary detail-button"
                                        @click=" updateBankInfo()"
                                    >
                                        <div v-if="!isConfirm">
                                            {{$t('banking.submit')}}
                                        </div>
                                        <Loading
                                            color="#000000"
                                            v-if="isConfirm"
                                            size="24"
                                            class="px-4 py-0"
                                        />
                                    </button>
                                </div>
                                <div class="col-12">
                                  <h3 class="text-white" style="font-size: 1rem; font-weight: 400 !important;">** {{$t('banking.note')}} **</h3>
                                  <span class="text-muted" style="font-size: 0.9rem;">
                                    {{ $t("banking.note_content") }}
                                  </span>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Toast, Dialog, Loading } from 'vant';
import { mapActions } from 'vuex';
import AccountSelect from './components/AccountSelect.vue';

export default {
  components: { AccountSelect, Loading },
  data() {
    return {
      imageUploader: [],
      selected_account: {
        account_id: null,
      },
      error: null,
      accounts: [
        {
          name: 'Krungsri Bank',
          id: 'Krungsri Bank',
          link: 'https://cdn.gold549.com/build/assets/img/payments/aya.png',
        },
        {
          name: 'True Wallet',
          id: 'True Wallet',
          link: 'https://cdn.gold549.com/build/assets/img/payments/aya.png',
        },
        {
          name: 'Bangkok Bank',
          id: 'Bangkok Bank',
          link: '/build/assets/img/banking/bangkokBank.jpeg',
        },
        {
          name: 'Bank of Thailand',
          id: 'Bank of Thailand',
          link: '/build/assets/img/banking/bankOfThailand.jpeg',
        },
        {
          name: 'Kasikorn Bank',
          id: 'Kasikorn Bank',
          link: '/build/assets/img/banking/kasikorn.png',
        },
        {
          name: 'Krung Thai Bank',
          id: 'Krung Thai Bank',
          link: '/build/assets/img/banking/krungthai.png',
        },
        {
          name: 'Siam Commercial',
          id: 'Siam Commercial',
          link: '/build/assets/img/banking/scb.jpeg',
        },
        {
          name: 'TMB Thanachart',
          id: 'TMB Thanachart',
          link: '/build/assets/img/banking/ttb.png',
        },
        {
          name: 'CIM Thai',
          id: 'CIM Thai',
          link: 'https://cdn.gold549.com/build/assets/img/payments/aya.png',
        },
        {
          name: 'SCB Bank',
          id: 'SCB Bank',
          link: 'https://cdn.gold549.com/build/assets/img/payments/aya.png',
        },
      ],
      account: {
        type: '',
        account_number: '',
        name: '',
      },
      imageUploader: [],
      withdrawData: {},
      errors: {},
      isConfirm: false,
    };
  },
  methods: {
    async fetchBankInfo() {
      try {
        const res = await axios.get('/user_bank', 
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`,
              },
          }
        );
        if(res.data.data) {
          this.account = res.data.data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    ...mapActions(['fetchUser']),
    async updateBankInfo() {
      try {
        this.error = null;
        if (!this.account.type) {
          this.error = this.$store.state.language === 'en'
            ? 'Please pick account type'
            : 'အကောင့်အမျိုးအစား ရွေးချယ်ပေးပါ။';
          return false;
        }
        if (!this.account.account_number) {
          this.error = this.$store.state.language === 'en'
            ? 'Please enter account number'
            : 'အကောင့်နံပါတ် ထည့်သွင်းပေးပါ။';
          return false;
        }
        if (!this.account.name) {
          this.error = this.$store.state.language === 'en'
            ? 'Please enter bank username'
            : 'Please enter bank username';
          return false;
        }

        this.isConfirm = true;

        await axios.put('/user_bank', this.account, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        });
        this.error = null;
        Toast.success('Success');
        this.isConfirm = false;
      } catch (error) {
        console.log(error);
        this.error = error.response.data
        this.isConfirm = false;
      }
      return true;
    },
  },
  async mounted() {
    // this.$store.commit('setLoading', true);
    await this.fetchBankInfo()
    const authUser = await this.fetchUser();
    // this.$store.commit('setLoading', false);
    if (!authUser) {
      this.$router.push('/auth/login');
    }
    // if(authUser && !authUser.is_verified) {
    //   this.$router.push('/auth/verify');
    // }
  },
};
</script>
<style scoped>
.detail-button {
  appearance: none;
  /* background-color: transparent; */
  background: linear-gradient(rgb(0, 194, 132) -19.51%, rgb(0, 61, 18) 106.26%) !important;
  border: none;
  text-transform: uppercase;
  border-radius: 14px;
  box-sizing: border-box;
  color: #fff !important;
  cursor: pointer;
  display: inline-block;
  font-family: Roobert,-apple-system,BlinkMacSystemFont,"Segoe UI",Helvetica,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol";
  font-size: 0.9rem;
  font-weight: 450;
  line-height: normal;
  margin: 0;
  min-height: 3rem;
  min-width: 0;
  outline: none;
  padding: 1px 5px;
  text-align: center;
  text-decoration: none;
  transition: all 300ms cubic-bezier(.23, 1, 0.32, 1);
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  width: 100%;
  will-change: transform;
}

.error {
  margin-bottom: 0;
  /* height: 40px; */
  display: flex;
  align-items: center;
  color: white;
  border: 1px solid rgb(255, 0, 0);
  border-radius: 8px;
  padding: 0px 15px;
  margin-top: 2rem;
  background: transparent;
  /* font-weight: bold; */
}


.custom-btn {
  background-image: linear-gradient(to right, #e52d27 0%, #b31217  51%, #e52d27  100%)}
         .custom-btn {
            /* margin: 10px; */
            /* padding: 15px 45px; */
            text-align: center;
            text-transform: uppercase;
            transition: 0.5s;
            background-size: 200% auto;
            color: white;            
            /* box-shadow: 0 0 20px #eee; */
            border-radius: 10px;
            display: block;
            width: 100% !important;
            height: 40px !important;
            border-radius: 25px;
          }

          .custom-btn:hover {
            background-position: right center; /* change the direction of the change here */
            color: #fff;
            text-decoration: none;
          }
         

.custom-input, .custom-input:active, .custom-input:focus {
    background: transparent !important;
    color: white !important;
    border-radius: 30px;
    /* border: 1px solid #FFFCFC !important; */
    border: 1px solid #b6afaf !important;
    text-align: center;
    /* height: 50px; */
    font-size: 1.3rem;
    font-weight: 300;
    box-shadow: none;
}
.image-container {
    width: 200px;
    height: 200px;
}
.image-container img {
    width: 100%;
    height: 100%;
    border-radius: 5px;
}
.number-container {
    border-radius: 5px;
    background: #e9ecef;
    justify-content: center;
}
.custom-file {
    height: auto;
}
/* @media (max-width: 768px) { */
    .main-wrapper {
        padding: 7px !important;
    }
/* } */
</style>
